import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';
import { ResizeDirective } from 'src/app/shared/directives/resize.directive';
import { StoryblokLinkUrlPipe } from '../../storyblok-link-url.pipe';
import { StoryblokLink } from '../../storyblok-types';
import { StoryblokDirective } from '../../storyblok.directive';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-sub-menu',
  standalone: true,
  imports: [
    CommonModule,
    BlockWrapperComponent,
    StoryblokDirective,
    ResizeDirective,
    RouterLink,
    ButtonDirective,
    RouterLinkActive,
    StoryblokLinkUrlPipe,
  ],
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.scss'],
})
export class SubMenuComponent {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];

  @Input() items: {
    link: StoryblokLink;
    buttonText: string;
    _editable: string;
  }[];
}
